export default __webpack_public_path__ + "static/media/block-layout-blue.14ba4876.svg";